<template>
<el-dialog
    title="确认出库"
    :visible.sync="xcVisible"
    :close-on-click-modal="false"
    width="88%"
    center
    :before-close="closeadd"
  >
  <div class="topForm">
    <div class="top" style="font-size:16px;margin-bottom:10px;margin-left:10px;">
      车号：<span >{{tEmptyOutstockMaster.outstockPlateNumber}}</span>
    </div>
  </div>
  <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
          <p>货物信息</p>
          <hr>
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <!-- <div v-if="item.cargoControlKey == '///'">总控</div> -->
                <div>{{(item.cargoControlKey).replace(/,/g,"/")}}</div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">总重量：</span>
                  <div>
                    <span style="color:red">{{Number(item.sumWeight).toFixed(4)}}</span><span> 吨 </span>
                    <span> / </span><span style="color:red">{{item.num}}</span><span> 件</span>
                  </div>
                </div>
                <div style="display: flex;" v-if="item.cargoControlKey != '不控货'">
                  <span style="margin-left:20px;" v-if='item.controlWeight == 1||item.controlPiece == 1'>未提量：</span>
                  <div>
                    <span v-if='item.controlWeight == 1'><span style="color:red">{{item.controlStockWeight}}</span><span> 吨</span></span>
                    <span v-if='item.controlPiece == 1'><span> / </span><span  style="color:red">{{item.controlStockNumber}}</span><span> 件</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-table
            max-height="300px"
            border
            bordersize="mini"
            size="mini"
            ref="tabref"
            :data="item.list"
            style="width:100%"
            highlight-current-row
            :header-cell-style="{background:'#F5F5F5',color:'black'}"
            :header-cell-class-name="Add"
        >
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="number" align="center" label="件数" width="">
            <template slot-scope="scope1">
                <el-input
                  v-model="scope1.row.number"
                  @blur="changeJianShu(scope1.row,scope1.row.number)"
                  v-number-input.float="0"
                  maxlength="50"
                  placeholder="请输入件数"
                  size="mini"
                  :disabled='scope1.row.flag =="磅重" && scope1.row.outPoundMethodName =="地磅"'
                ></el-input>
             </template>
          </el-table-column>
          <el-table-column prop="weight" align="center" label="理重（吨）" width="">
            <template slot-scope="scope1">
              <el-input
                v-model="scope1.row.weight"
                v-number-input.float="4"
                maxlength="50"
                placeholder="请输入重量"
                size="mini"
                :disabled="true"
                @blur="weightInput(scope1.row,scope1.row.weight)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="weighingWeight" align="center"  label="过磅净重（吨）" width="150">
            <template slot-scope="scope1">
              <el-input
                v-model="scope1.row.weighingWeight"
                v-number-input.float="4"
                maxlength="50"
                placeholder="请输入过磅净重"
                size="mini"
                :disabled='scope1.row.flag =="磅重" && scope1.row.outPoundMethodName =="地磅"'
                @blur="weighingWeight(scope1.row,scope1.row.weighingWeight)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="warehouseName" align="center" label="仓位">
              <!-- <template slot-scope="scope1">
                <el-select
                clearable
                  filterable
                  @change="changeCangWei(scope1.row,scope1.row.warehouseId)"
                  v-model="scope1.row.warehouseId"
                  size="mini"
                  placeholder="请选择仓位"
                >
                  <el-option
                    v-for="(item,index) in scope1.row.tEmptyStockWarehouseList"
                    :key="index"
                    :label="item.warehouseName"
                    :value="item.warehouseId"
                  ></el-option>
                </el-select>
              </template> -->
            </el-table-column>
          <!-- <el-table-column prop="stockWarehouseNumber" align="center" label="仓位可提件数">
            <template slot-scope="scope1">
              <el-input
                :disabled="true"
                v-model="scope1.row.stockWarehouseNumber"
                maxlength="50"
                placeholder="请输入仓位可提件数"
                size="mini"
              ></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="placeOfOrigin" align="center" label="产地" width=""></el-table-column>
          <el-table-column prop="productTypeName" align="center" label="货物类型" width=""></el-table-column>
          <el-table-column prop="specification" align="center" label="规格" width=""></el-table-column>
          <el-table-column prop="model" align="center" label="材质"  width=""></el-table-column>
          <el-table-column prop="shipForecastNo" align="center" label="预报编号"  width="300"></el-table-column>
        </el-table>
        </div>
        <div slot="footer" style="text-align:center;margin:15px;">
          <el-button @click="closeadd">取 消</el-button>
          <el-button type="primary" :loading="confirmLoading" @click="confirmClick">确认出库</el-button>
          <el-button type="primary" :loading="confirmLoadingDY" @click="confirmClickDY">确认出库并打印</el-button>
        </div>
  </el-dialog>
</template>

<script>
import {
  getOutstockInfoJanFaForConfirm, // 查询出库单主表子表所有信息（打印、修改回显、确认出库回显用）
  confirmWhOutstockJanFaForSummary, // 确认出库
  JfgetNumberForBillStockWarehouse,
  JfvirtualControlBean
} from '@/api/wms-stock'
// import { dateFormat1 } from '@/utils/util.js'
export default {
  name: 'xieCheDialog',
  data () {
    return {
      confirmLoading: false,
      selectSijiVisible: false,
      TableIndex: 0,
      hasValidFlag: true,
      emptyBillType: '',
      billNo: '',
      addBtnShow: false,
      allDataList: [],
      noBillId: false,
      plateNumberOption: [],
      tEmptyOutstockMaster: {},
      confirmLoadingDY: false,
      checkFlag: true
    }
  },
  props: {
    xcVisible: {
      type: Boolean,
      default: false
    },
    outstockId: {
      type: Number
    }
  },
  watch: {
  },
  async created () {
    await this.getOutstockInfoJanFa()
  },
  methods: {
    // 小星星
    Add (obj) {
      if (obj.column.property == 'number') {
        return 'star'
      }
    },
    closeadd () {
      this.$emit('update:xcVisible', false)
    },
    changeJianShu (row, val) {
      if (val) {
        this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(4))
        if (row.flag == '理重') {
          this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
        } else {
          this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(4))
        }
      } else {
        this.$set(row, 'weight', '0.000')
        this.$set(row, 'allWeight', '0.000')
        this.$message.error('发货件数不能为空')
      }
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    weightInput (row, val) {
      if (row.flag == '理重') {
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
      } else {
        this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(4))
      }
      row.weight = Number(val).toFixed(4)
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    // 过磅净重
    weighingWeight (row, val) {
      // weighingWeight（过磅净重（吨）  出库计重方式为磅重的时候必填 ）
      // allWeight（总重量（吨）  必填 出库计重方式为理重的时候=理重（吨）、出库计重方式为磅重的时候=过磅净重（吨））
      row.weighingWeight = Number(row.weighingWeight).toFixed(4)
      console.log(row.weighingWeight, 'row.flag')
      if (row.flag == '理重') {
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
      } else {
        this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(4))
      }
      this.allDataList.forEach((item, index) => {
        // this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    changeCangWei (row, val) {
      console.log(row)
      row.tEmptyStockWarehouseList.forEach((item, index) => {
        if (val == item.warehouseId) {
          row.singletonWeight = item.singletonWeight
          row.warehouseName = item.warehouseName
          this.$set(row, 'stockWarehouseId', item.stockWarehouseId)
          JfgetNumberForBillStockWarehouse({
            stockWarehouseId: row.stockWarehouseId
          }).then(res => {
            this.$set(row, 'stockWarehouseNumber', res.whAvailableNumber)
              this.$set(row, 'whNumber', res.whNumber)
              this.$set(row, 'whWeight', res.whWeight)
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      })
    },
    // 获取数据
    getOutstockInfoJanFa () {
      getOutstockInfoJanFaForConfirm({
        outstockId: this.outstockId
      }).then(res => {
        this.getData(res)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    async getData (res) {
      this.tEmptyOutstockMaster = res.tEmptyOutstockMaster
      let tEmptyOutstockSummaryList = res.mapList

      if (tEmptyOutstockSummaryList.length != 0) {
        let mapData = new Map()
        for (const item of tEmptyOutstockSummaryList) {
          let cargoControlKey = item.tEmptyOutstockSummary.cargoControlKey
          if (cargoControlKey == ',,,') {
            cargoControlKey = '总控'
          }
          item.tEmptyOutstockSummary.flag = item.flag
          item.tEmptyOutstockSummary.outPoundMethodName = item.outPoundMethodName
          let keyArr = cargoControlKey.split(',')
          console.log(item)
          if (item.flag == '理重') {
            item.tEmptyOutstockSummary.allWeight = item.tEmptyOutstockSummary.weight
          } else {
            item.tEmptyOutstockSummary.allWeight = item.tEmptyOutstockSummary.weighingWeight
          }

          if (mapData.has(cargoControlKey)) {
            let dataObj = mapData.get(cargoControlKey)
            // dataObj.sumWeight = sum
            if (item.flag == '理重') {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weight
            } else {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weighingWeight
            }
            // dataObj.sumWeight = (dataObj.sumWeight + item.tEmptyOutstockSummary.weight).toFixed(4)
            dataObj.num = dataObj.num + item.tEmptyOutstockSummary.number
            dataObj.releaseFlag = 0
            this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', item.tEmptyStockWarehouseList)
            dataObj.list.push(item.tEmptyOutstockSummary)
          } else {
            let params = {
              oneCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
              twoCustomerTaxId: this.tEmptyOutstockMaster.customerTaxId, // （二级货主纳税人识别号  必填）
              organizationId: this.tEmptyOutstockMaster.organizationId, // （仓储租户id  必填）
              productionPlaceName: keyArr[0], // （产地  必填）
              goodTypeName: keyArr[1], // （货物类型名称  必填
              specificationName: keyArr[2], // （规格  必填）
              materialName: keyArr[3] // （材质  必填）
            }
            let res = ''
            let isEnableObj = {}
            if (keyArr[0] != '不控货') {
              res = await JfvirtualControlBean(params)
            }
            if (res) {
              isEnableObj = JSON.parse(res)
            }
            console.log(isEnableObj, 'isEnableObj')
            let dataObj = {
              cargoControlKey: cargoControlKey,
              releaseFlag: 0,
              list: [],
              controlStockWeight: isEnableObj.controlStockWeight,
              controlStockNumber: isEnableObj.controlStockNumber,
              controlWeight: isEnableObj.controlWeight,
              controlPiece: isEnableObj.controlPiece,
              strictReminder: isEnableObj.strictReminder,
              isEnable: isEnableObj.isEnable,
              sumWeight: 0
            }
            this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', item.tEmptyStockWarehouseList)
            dataObj.list.push(item.tEmptyOutstockSummary)
            console.log(dataObj, 'dataObj11111')
            if (item.flag == '理重') {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weight
            } else {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weighingWeight
            }
            // dataObj.sumWeight = sum
            dataObj.num = item.tEmptyOutstockSummary.number
            mapData.set(cargoControlKey, dataObj)
            console.log(mapData, 'mapDatamapDatamapDatamapData')
          }
        }
        this.allDataList = Array.from(mapData.values())
        console.log(this.allDataList, 'this.allDataList')
      } else {
        this.allDataList = []
      }
    },
    recursionCheck (index, type) {
      console.log('asdfasdfads', index)
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        if (type == 'dayin') {
          console.log('dayin')
          this.confirmWhOutstockB()
        } else {
          this.confirmWhOutstock()
        }
      }
      if (index > this.allDataList.length) {
        // todo
      }
      const item = this.allDataList[index]
      // if (item) {
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          if (item.controlPiece == '1' && item.controlWeight == '1') {
            if (item.num > item.controlStockNumber || item.sumWeight > item.controlStockWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的数据大于未提量')
            } else {
              this.recursionCheck(index + 1, type)
            }
          } else if (item.controlPiece == '1') { // 控件
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于未提量')
            } else {
              this.recursionCheck(index + 1, type)
            }
          }
          if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.controlStockWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于未提量')
            } else {
              this.recursionCheck(index + 1, type)
            }
          }
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1' && item.controlWeight == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于未提量')
              return
            }
            if (item.sumWeight > item.controlStockWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于未提量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                console.log(item.cargoControlKey, item.releaseFlag)
                this.recursionCheck(index + 1, type)
              }).catch(() => {
                // this.$message.info('出库操作已取消')
              })
            } else {
              this.recursionCheck(index + 1, type)
            }
          } else if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于未提量')
            } else {
              this.recursionCheck(index + 1, type)
            }
          } else if (item.controlWeight == '1') {
            console.log('控吨')
            if (item.sumWeight > item.controlStockWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于未提量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                console.log(item.cargoControlKey, item.releaseFlag)
                this.recursionCheck(index + 1, type)
              }).catch(() => {
                // this.$message.info('出库操作已取消')
              })
            } else {
              this.recursionCheck(index + 1, type)
            }
          }
        }
      } else {
        // if (type == 'dayin') {
        //   console.log('dayin')
        //   this.confirmWhOutstockB()
        // } else {
        //   this.confirmWhOutstock()
        // }
        this.recursionCheck(index + 1, type)
      }
      // }
    },
    confirmClick () {
      // strictReminder 严控：0 或提示：1
      for (const item of this.allDataList) {
        item.releaseFlag = 0
        for (let i = 0; i < item.list.length; i++) {
          if (item.list[i].number / 1 == 0) {
            this.$message({ message: '件数不能为空或0', type: 'error' })
            return
          } else if (item.list[i].flag == '磅重' && item.list[i].weighingWeight / 1 == 0) {
            this.$message({ message: '磅重不能为空或0', type: 'error' })
            return
          }
        }
      }
      this.recursionCheck(0)
    },
    // 调接口
    confirmWhOutstock () {
      this.confirmLoading = true
      console.log('hello world')
      let obj = {
        tEmptyOutstockMaster: {
          outstockId: this.tEmptyOutstockMaster.outstockId, // （出库单id  必填）
          billId: this.tEmptyOutstockMaster.billId, // （出库提单id  必填）
          primaryCustomerName: this.tEmptyOutstockMaster.primaryCustomerName, // （一级货主名称  必填）
          primaryCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主id  必填）
          customerName: this.tEmptyOutstockMaster.customerName, // （二级货主名称  必填）
          customerTaxId: this.tEmptyOutstockMaster.customerTaxId // （二级货主id 必填）
        },
        queryList: this.allDataList
      }
      console.log(obj)
      confirmWhOutstockJanFaForSummary(obj).then(res => {
        this.confirmLoading = false
        this.$emit('update:xcVisible', false)
        this.$message.success('成功')
        this.$parent.chaxun()
      }).catch(err => {
        this.confirmLoading = false
        if (err.code == '-200') {
          // console.log(JSON.parse(err.message))
          this.$message.error(JSON.parse(err.message).msg)
          let cargoControlKey = JSON.parse(err.message).cargoControlKey
          if (cargoControlKey != '不控货') {
            let paramsObj = {}
            if (cargoControlKey == '总控') {
              paramsObj = {
                oneCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.tEmptyOutstockMaster.customerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.tEmptyOutstockMaster.organizationId // （仓储租户id  必填）
              }
            } else {
              let controlKeyArr = cargoControlKey.split(',')
              paramsObj = {
                oneCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.tEmptyOutstockMaster.customerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.tEmptyOutstockMaster.organizationId, // （仓储租户id  必填）
                productionPlaceName: controlKeyArr[0], // （产地  必填）
                goodTypeName: controlKeyArr[1], // （货物类型名称  必填
                specificationName: controlKeyArr[2], // （规格  必填）
                materialName: controlKeyArr[3] // （材质  必填）
              }
            }
            JfvirtualControlBean(paramsObj).then(res => {
              let isEnableObjB = JSON.parse(res)
              for (let index = 0; index < this.allDataList.length; index++) {
                console.log(this.allDataList[index], 'this.allDataList[index]')
                if (this.allDataList[index].cargoControlKey == cargoControlKey) {
                  this.allDataList[index].controlStockWeight = isEnableObjB.controlStockWeight
                  this.allDataList[index].controlStockNumber = isEnableObjB.controlStockNumber
                }
              }
            }).catch(err => {
              this.$message.error(err.message)
            })
          }
        } else {
          this.$message.error(err.message)
        }
      })
    },
    // 打印
    confirmClickDY () {
      // strictReminder 严控：0 或提示：1
      for (const item of this.allDataList) {
        for (let i = 0; i < item.list.length; i++) {
          if (item.list[i].number / 1 == 0) {
            this.$message({ message: '件数不能为空或0', type: 'error' })
            return
          } else if (item.list[i].flag == '磅重' && item.list[i].weighingWeight / 1 == 0) {
            console.log(222)
            this.$message({ message: '磅重不能为空或0', type: 'error' })
            return
          }
        }
      }
      this.recursionCheck(0, 'dayin')
    },
    // 打印调接口
    confirmWhOutstockB () {
      this.confirmLoadingDY = true
      let obj = {
        tEmptyOutstockMaster: {
          outstockId: this.tEmptyOutstockMaster.outstockId, // （出库单id  必填）
          billId: this.tEmptyOutstockMaster.billId, // （出库提单id  必填）
          primaryCustomerName: this.tEmptyOutstockMaster.primaryCustomerName, // （一级货主名称  必填）
          primaryCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主id  必填）
          customerName: this.tEmptyOutstockMaster.customerName, // （二级货主名称  必填）
          customerTaxId: this.tEmptyOutstockMaster.customerTaxId // （二级货主id 必填）
        },
        queryList: this.allDataList
      }
      confirmWhOutstockJanFaForSummary(obj).then(res => {
        this.confirmLoadingDY = false
        this.$emit('update:xcVisible', false)
        this.$message.success('成功')
        this.$router.push({ // 核心语句
          path: '/yycChuKuDan', // 跳转的路径
          query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
            id: this.tEmptyOutstockMaster.outstockId
          }
        })
        // this.$parent.chaxun()
      }).catch(err => {
        this.confirmLoadingDY = false
        if (err.code == '-200') {
          console.log(JSON.parse(err.message))
          this.$message.error(JSON.parse(err.message).msg)
          let cargoControlKey = JSON.parse(err.message).cargoControlKey
          if (cargoControlKey != '不控货') {
            let paramsObj = {}
            if (cargoControlKey == '总控') {
              paramsObj = {
                oneCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.tEmptyOutstockMaster.customerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.tEmptyOutstockMaster.organizationId // （仓储租户id  必填）
              }
            } else {
              let controlKeyArr = cargoControlKey.split(',')
              paramsObj = {
                oneCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.tEmptyOutstockMaster.customerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.tEmptyOutstockMaster.organizationId, // （仓储租户id  必填）
                productionPlaceName: controlKeyArr[0], // （产地  必填）
                goodTypeName: controlKeyArr[1], // （货物类型名称  必填
                specificationName: controlKeyArr[2], // （规格  必填）
                materialName: controlKeyArr[3] // （材质  必填）
              }
            }
            JfvirtualControlBean(paramsObj).then(res => {
              let isEnableObjB = JSON.parse(res)
              for (let index = 0; index < this.allDataList.length; index++) {
                console.log(this.allDataList[index], 'this.allDataList[index]')
                if (this.allDataList[index].cargoControlKey == cargoControlKey) {
                  this.allDataList[index].controlStockWeight = isEnableObjB.controlStockWeight
                  this.allDataList[index].controlStockNumber = isEnableObjB.controlStockNumber
                }
              }
            }).catch(err => {
              this.$message.error(err.message)
            })
          }
        } else {
          this.$message.error(err.message)
        }
      })
    }

  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before{
    content: '*' !important;
    color: red !important;
  }
</style>
